import React, { Component } from 'react';
import $ from 'jquery';
import {hit} from '../../metrics';
import CaseFooter from '../CaseFooter';
import HelmetSite from '../HelmetSite';
import './style.css';

class Voshod extends Component{
  handleVideoPlay = () => {
    const video = document.querySelector('#voshod .video video');
    const section = document.querySelector('#voshod .section6');
    if (!video || !section) return;

    if (video.paused) {
      video.play();
      section.classList.add('is-playing');
    } else {
      video.pause();
      section.classList.remove('is-playing');
    }
  };

  handleVideoPause = () => {
    const video = document.querySelector('#voshod .video video');
    const section = document.querySelector('#voshod .section6');
    if (!video || !section) return;
    video.pause();
    section.classList.remove('is-playing');
  };

  handleVideoEnded = () => {
    const section = document.querySelector('#voshod .section6');
    if (section) section.classList.remove('is-playing');
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    setTimeout(() => {
      $('body').addClass('fadepage');
    }, 100);
  }

  componentWillUnmount() {
    $('body').removeClass('fadepage');
  }
  
  render(){
    return(
      <div className="case">
        <div className="case-content" id="voshod">
          <section className="section1">
            <img src="/cases/img/voshod/new/img1.svg" />
          </section>

          <section className="section2">
            <div className="main">
              <h1 className="title">Девелопер “Voshod”</h1>
              <dl className="details">
                <div className="detail">
                  <dt>Клиент</dt>
                  <dd>Voshod</dd>
                </div>
                <div className="detail">
                  <dt>Виды работ</dt>
                  <dd>Сайт</dd>
                </div>
              </dl>
            </div>
            <div className="description">
              <p>Безупречно выстроенный дизайн на&nbsp;главном элементе фирменного стиля&nbsp;— круге и&nbsp;его антониме, прямоугольнике. Ничего лишнего, только самое главное.</p>
              <p>Необычное решение с&nbsp;вертикальным расположением меню поддерживает строгое, очень геометрическое звучание дизайна.</p>
            </div>
          </section>

          <section className="section3">
            <div>
              <img src="/cases/img/voshod/new/img2.webp" />
              <span className="dot dot1" />
              <span className="dot dot2" />
              <span className="scroll" />
            </div>
          </section>

          <section className="section4">
            <div>
              <img src="/cases/img/voshod/new/img3.webp" />
            </div>
            <div>
              <img src="/cases/img/voshod/new/img4.webp" />
            </div>
          </section>

          <section className="section5">
            <div>
              <img src="/cases/img/voshod/new/img5.webp" />
              <span className="dot dot1" />
              <span className="dot dot2" />
            </div>
            <div>
              <img src="/cases/img/voshod/new/img6.webp" />
            </div>
          </section>

          <section className="section6">
            <div className="video">
              <video src="/cases/img/voshod/video.mp4" poster="/cases/img/voshod/new/poster.webp" playsInline preload="metadata" onClick={this.handleVideoPause} onEnded={this.handleVideoEnded} />
            </div>
            <button className="play" type="button" aria-label="Play video" onClick={this.handleVideoPlay}>
              <img src="/cases/img/voshod/new/play.svg" alt="" />
            </button>
          </section>

          <section className="section7">
            <img src="/cases/img/voshod/new/img7.webp" />
          </section>

          <section className="section8">
            <div>
              <img src="/cases/img/voshod/new/img8.webp" />
            </div>
            <div>
              <img src="/cases/img/voshod/new/img9.webp" />
            </div>
          </section>

          <section className="section9">
            <img src="/cases/img/voshod/new/img10.webp" />
          </section>

          <section className="section10">
            <div>
              <div>
                <img src="/cases/img/voshod/new/img11.webp" />
                <span className="dot" />
              </div>
            </div>
            <div>
              <div>
                <p>Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко&nbsp;всем необходимым функциям в&nbsp;любое время и&nbsp;в&nbsp;любом месте.</p>
                <p>Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и&nbsp;интуитивной. При&nbsp;этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и&nbsp;создавая гармоничное восприятие даже на&nbsp;небольших экранах.</p>
              </div>
            </div>
          </section>

          <section className="section11">
            <div>
              <img src="/cases/img/voshod/new/img12.webp" />
            </div>
            <div>
              <img src="/cases/img/voshod/new/img13.webp" />
            </div>
            <div>
              <img src="/cases/img/voshod/new/img14.webp" />
              <span className="dot dot1" />
              <span className="dot dot2" />
            </div>
            <div>
              <img src="/cases/img/voshod/new/img15.webp" />
            </div>
          </section>
        </div>

        <CaseFooter 
          to="/projects/ahead" 
          title="Ahead" 
          img="/cases/img/next/ahead_next.webp" 
        />

        <HelmetSite title="Voshod" />
      </div>
    )
  }
}

export default Voshod
